import styled, { css } from 'styled-components';
import { HiddenProps } from './Hidden';

export const HiddenContainer = styled.div<HiddenProps>`
	${({ hidden = false }) => css`
		${hidden && 'visibility: hidden;'}
		display: inline-flex;
	`}
`;
